<template>
  <v-card>
    <v-card-text>
      <v-data-table
        @click:row="rowClick"
        single-select
        show-select
        v-model="selectionModel"
        dense
        v-on:item-selected="updateSelection"
        :headers="componentRequirementHeaders"
        :items="admin.componentRequirementList"
        :items-per-page="15"
        no-data-text="NONE"
        :hide-default-footer="admin.componentRequirementList.length == 0"
        :hide-default-header="admin.componentRequirementList.length == 0"
      >
        <template v-slot:item.attributeId="{ item }">
          {{ getAttributeName(item.attributeId) }}
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn dark color="blue darken-2" @click="addNewComponentRequirement"
        ><v-icon>mdi-plus</v-icon> ADD NEW</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        componentRequirementHeaders: [
          { text: 'ID', value: 'id', width: '80px' },
          { text: 'ATTRIBUTE', value: 'attributeId' },
          { text: 'REQUIREMENT TYPE', value: 'requirementType' },
          { text: 'VALUE', value: 'value' },
          { text: 'TARGET ENTITY', value: 'targetEntity' }
        ]
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      selectionModel: {
        get() {
          return this.admin.selectedComponentRequirementSelectionModel;
        },
        set(value) {
          this.$store.commit('admin/setSelectionModel', {
            entity: 'selectedComponentRequirementSelectionModel',
            value: value
          });
          this.$store.dispatch('admin/getComponentRequirementList');
        }
      }
    },
    methods: {
      /**
       * returns the description for given componentId
       */
      getAttributeName(attributeId) {
        return this.admin.attributeList.find((x) => x.id == attributeId)?.name;
      },
      /**
       * Handles row click
       */
      rowClick: function (item, row) {
        row.select(!row.isSelected);
      },
      /**
       * Adds a new Component Attribute to currently selected component
       */
      addNewComponentRequirement() {
        this.$store.commit('admin/setSelectedComponentRequirement', {
          id: 'new',
          componentId: 0,
          childComponentTypeId: 0,
          attributeId: 0,
          requirementType: '',
          value: ''
        });
        // clear selection models
        this.clearThisSelectionModel();
      },
      /**
       * Fires when an item is selected in the data table
       */
      updateSelection(data) {
        if (data.value) {
          this.$store.commit(
            'admin/setSelectedComponentRequirement',
            data.item
          );
          this.$store.dispatch(
            'admin/getAttributeValueList',
            data.item.attributeId
          );
        } else {
          this.$store.commit('admin/setSelectedComponentRequirement', null);
        }
        this.clearChildSelectionModels();
      },
      /**
       * Clears this components selection model
       */
      clearThisSelectionModel() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedComponentRequirementSelectionModel',
          value: null
        });
      },
      /**
       * Clears Child Selection Models
       */
      clearChildSelectionModels() {}
    }
  };
</script>
